/* Midnight Prophet — product gallery lightbox.
   Double-tap / double-click (or the expand button) on a [data-mp-gallery] main
   image opens a full-screen viewer with a thumbnail strip and prev/next/close. */
(function () {
  var lb, state = { images: [], index: 0, onClose: null }, bound = false;

  function build() {
    if (lb) return lb;
    lb = document.createElement('div');
    lb.className = 'mp-lb';
    lb.setAttribute('hidden', '');
    lb.innerHTML =
      '<button class="mp-lb__close" type="button" aria-label="Close">✕</button>' +
      '<button class="mp-lb__nav mp-lb__prev" type="button" aria-label="Previous">‹</button>' +
      '<figure class="mp-lb__stage"><img class="mp-lb__img" alt=""></figure>' +
      '<button class="mp-lb__nav mp-lb__next" type="button" aria-label="Next">›</button>' +
      '<div class="mp-lb__counter"><span class="mp-lb__cur">1</span> / <span class="mp-lb__total">1</span></div>' +
      '<div class="mp-lb__thumbs"></div>';
    document.body.appendChild(lb);
    return lb;
  }

  function render() {
    lb.querySelector('.mp-lb__img').src = state.images[state.index];
    lb.querySelector('.mp-lb__cur').textContent = state.index + 1;
    lb.querySelector('.mp-lb__total').textContent = state.images.length;
    lb.querySelectorAll('.mp-lb__thumb').forEach(function (t, i) {
      t.classList.toggle('is-active', i === state.index);
      if (i === state.index) t.scrollIntoView({ block: 'nearest', inline: 'center' });
    });
  }
  function go(d) { state.index = (state.index + d + state.images.length) % state.images.length; render(); }

  function close() {
    if (!lb) return;
    lb.classList.remove('is-open');
    document.documentElement.classList.remove('mp-lb-lock');
    setTimeout(function () { lb.setAttribute('hidden', ''); }, 280);
    if (state.onClose) state.onClose(state.index);
  }

  function open(images, index, onClose) {
    build();
    if (!bound) {
      lb.querySelector('.mp-lb__close').addEventListener('click', close);
      lb.querySelector('.mp-lb__prev').addEventListener('click', function () { go(-1); });
      lb.querySelector('.mp-lb__next').addEventListener('click', function () { go(1); });
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('mp-lb__stage')) close(); });
      // swipe
      var x0 = null;
      lb.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 50) go(dx < 0 ? 1 : -1);
        x0 = null;
      });
      bound = true;
    }

    state.images = images; state.index = index || 0; state.onClose = onClose || null;
    var multi = images.length > 1;
    lb.querySelector('.mp-lb__prev').style.display = multi ? '' : 'none';
    lb.querySelector('.mp-lb__next').style.display = multi ? '' : 'none';
    lb.querySelector('.mp-lb__counter').style.display = multi ? '' : 'none';

    var tw = lb.querySelector('.mp-lb__thumbs');
    tw.style.display = multi ? '' : 'none';
    tw.innerHTML = '';
    images.forEach(function (src, i) {
      var b = document.createElement('button');
      b.className = 'mp-lb__thumb'; b.type = 'button'; b.setAttribute('aria-label', 'View ' + (i + 1));
      b.innerHTML = '<img src="' + src + '" alt="">';
      b.addEventListener('click', function () { state.index = i; render(); });
      tw.appendChild(b);
    });

    render();
    lb.removeAttribute('hidden');
    document.documentElement.classList.add('mp-lb-lock');
    requestAnimationFrame(function () { lb.classList.add('is-open'); });
  }

  document.addEventListener('keydown', function (e) {
    if (!lb || lb.hasAttribute('hidden')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') go(-1);
    else if (e.key === 'ArrowRight') go(1);
  });

  function initGallery(g) {
    if (g.__mpGallery) return; g.__mpGallery = true;
    var main = g.querySelector('[data-mp-main]');
    if (!main) return;
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('.mp-pdp__thumb'));

    function images() {
      return thumbs.length ? thumbs.map(function (t) { return t.getAttribute('data-full'); }) : [main.getAttribute('src')];
    }
    function currentIndex() {
      var active = g.querySelector('.mp-pdp__thumb.is-active');
      return active ? Math.max(0, thumbs.indexOf(active)) : 0;
    }
    function openLb() {
      open(images(), currentIndex(), function (idx) {
        var imgs = images();
        main.removeAttribute('srcset');
        main.src = imgs[idx];
        if (thumbs[idx]) {
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumbs[idx].classList.add('is-active');
        }
      });
    }

    main.style.cursor = 'zoom-in';
    main.addEventListener('dblclick', openLb);
    var lastTap = 0;
    main.addEventListener('touchend', function (e) {
      var now = Date.now();
      if (now - lastTap < 300) { e.preventDefault(); openLb(); }
      lastTap = now;
    });
    var expand = g.querySelector('[data-mp-expand]');
    if (expand) expand.addEventListener('click', openLb);
  }

  function initAll() { document.querySelectorAll('[data-mp-gallery]').forEach(initGallery); }
  if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
